import React from 'react';
import axios from 'axios';
import cx from 'classnames';
import qs from 'qs';
import Widget from '../Widget';
import moment from 'moment';
import Modal from 'react-modal';
import { validators } from './validators';
import {useHistory} from 'react-router-dom';
import CardWrapperModal from "../CardWrapperModal";
import {CardElement, IbanElement} from '@stripe/react-stripe-js';
import {STRIPE_STYLING} from "../../global/stripe";

moment.locale('nl');

const translations = {
  year: 'jaarabonnement',
  month: 'maandabonnement',
};

const planSpecs = {
  rookie: {
    title: 'Postcode API Rookie',
    weight: 1,
  },
  small: {
    title: 'Postcode API Small',
    weight: 2,
  },
  standard: {
    title: 'Postcode API Standard',
    weight: 3,
  },
  plus: {
    title: 'Postcode API Plus',
    weight: 4,
  },
  pro: {
    title: 'Postcode API Pro',
    weight: 5,
  },
};



class SignupFormWithoutRouter extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubscriptionChange = this.handleSubscriptionChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    let initialState = {
      isRendered: false,
      companyName: '',
      firstName: '',
      globalError: null,
      lastName: '',
      email: '',
      invoiceEmail: '',
      invoiceStreet: '',
      invoiceNumber: '',
      invoiceAddition: '',
      invoicePostcode: '',
      invoiceCity: '',
      invoiceReference: '',
      paymentMethod: 'creditcard',
      cardNumber: '',
      cardExpMonth: '',
      cardExpYear: '',
      cardCvc: '',
      debitIban: '',
      debitOwner: '',
      subscription: {
        plan: 'standard',
        period: 'year',
      }
    };

    if (typeof window !== 'undefined') {
      if (window.location.search !== '') {
        const query = qs.parse(window.location.search.substr(1));
        if (query) {
          if (query.plan && planSpecs[query.plan]) initialState.subscription.plan = query.plan;
          if (query.period && (query.period === 'month' || query.period === 'year')) {
            initialState.subscription.period = query.period;
          }
        }
      }
    }

    initialState.subscription.startsAt = moment().format('YYYY-MM-DD');
    initialState.subscription.endsAt = moment().add(1, initialState.subscription.period).format('YYYY-MM-DD');

    this.state = {
      submitting: false,
      errors: {},
      values: initialState,
    };
  }

  componentDidMount() {
    this.setState((state) => ({...state, isRendered: true}));
  }

  handlePeriodChange = (period) => {
    let paymentMethod = period === 'month' ? 'creditcard' : this.state.values.paymentMethod;

    this.setState({
      values: {
        ...this.state.values,
        paymentMethod: paymentMethod,
        subscription: {
          ...this.state.values.subscription,
          period: period
        }
      }
    })
  };

  handleWidgetError = () => {
    document.getElementById('street').readOnly = false;
    document.getElementById('street').disabled = false;
    document.getElementById('city').readOnly = false;
    document.getElementById('city').disabled = false;
  };

  handleWidgetSuccess = result => {
    const errors = Object.assign({}, this.state.errors);

    if (errors.hasOwnProperty('invoicePostcode')) {
      delete errors['invoicePostcode'];
      delete errors['invoiceCity'];
      delete errors['invoiceStreet'];
      delete errors['invoiceNumber'];
      delete errors['invoiceAddition'];
    }

    const values = Object.assign(this.state.values, {
      invoiceStreet: result.street,
      invoiceCity: result.city,
    });

    this.setState({ errors, values });
  };

  handleInputChange(event) {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({
      values: Object.assign(this.state.values, {
        [fieldName]: fieldValue,
      }),
    });
  }

  handleSubscriptionChange(plan, period) {
    let startsAt = moment().format('YYYY-MM-DD');
    let endsAt = moment().add(1, period).format('YYYY-MM-DD');
    let paymentMethod = this.state.values.paymentMethod;

    if (['rookie', 'small'].includes(plan)) {
      paymentMethod = 'creditcard';
    }

    this.setState({
      values: {
        ...this.state.values,
        paymentMethod: paymentMethod,
        subscription: {
          ...this.state.values.subscription,
          ...{
            plan,
            period,
            startsAt,
            endsAt
          },
        }
      },
    }, () => this.closeSubscriptionModal());
  }

  handleInputBlur(event) {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    if (validators['baseForm'][fieldName]) {
      this.setState({
        errors: Object.assign(this.state.errors, {
          [fieldName]: validators['baseForm'][fieldName].call(this, fieldValue),
        }),
      });
    }

    if (validators[this.state.values.paymentMethod][fieldName]) {
      this.setState({
        errors: Object.assign(this.state.errors, {
          [fieldName]: validators[this.state.values.paymentMethod][fieldName].call(this, fieldValue),
        }),
      });
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    const errors = {};

    Object.keys(validators['baseForm']).forEach(fieldName => {
      const error = validators['baseForm'][fieldName].call(undefined, this.state.values[fieldName]);
      if (error) errors[fieldName] = error;
    });

    Object.keys(validators[this.state.values.paymentMethod]).forEach(fieldName => {
      const error = validators[this.state.values.paymentMethod][fieldName].call(undefined, this.state.values[fieldName]);
      if (error) errors[fieldName] = error;
    });

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({
      submitting: true,
      globalError: null
    });

    const endpoint = `https://${process.env.REACT_APP_API_HOST}/admin/signup`;

    const payload = Object.keys(this.state.values).reduce((total, current) => {
      if (current === 'subscription') {
        return {
          ...total,
          plan: this.state.values[current].plan,
          period: this.state.values[current].period,
        }
      }

      return {
        ...total,
        [current]: this.state.values[current]
      };
    }, {});

    let promise;

    if (payload.paymentMethod === 'creditcard') {
      promise = axios.post(`https://${process.env.REACT_APP_API_HOST}/admin/payment-intent`)
        .then(async (res) => {

          return this.props.stripe.confirmCardSetup(
            res.data.clientSecret, {
              payment_method: { card: this.props.elements.getElement(CardElement) }
            }
          ).then((result) => {
            if (result.error) {
              this.setState(state => ({
                submitting: false,
                errors: {
                  ...state.errors,
                  creditcard: result.error.message
                },
              }));
              return null;
            } else if (result.setupIntent) {
              return {
                customerId: res.data.customerId,
                paymentMethodId: result.setupIntent.payment_method
              };
            }
          });
        })
        .catch(err => {
          this.setState({
            submitting: false,
            globalError: err
          });

          setTimeout(() => {
            const el = document.getElementById('global-error');
            if (!el) {
              return;
            }
            window.scrollTo({
              top: window.scrollY + el.getBoundingClientRect().y - 20,
              behavior: 'smooth'
            });
          }, 1);
        });
    } else if (payload.paymentMethod === 'directDebit') {
      promise = axios.post(`https://${process.env.REACT_APP_API_HOST}/admin/payment-intent`)
        .then(async (res) => {

          const iban = this.props.elements.getElement(IbanElement);

          return this.props.stripe.confirmSepaDebitSetup(
            res.data.clientSecret, {
              payment_method: {
                sepa_debit: iban,
                billing_details: {
                  name: this.state.values.debitOwner,
                  email: this.state.values.email
                }
              }
            }
          ).then((result) => {
            if (result.error) {
              this.setState(state => ({
                submitting: false,
                errors: {
                  ...state.errors,
                  debitCard: result.error.message
                },
              }));
              return null;
            } else if (result.setupIntent) {
              return {
                customerId: res.data.customerId,
                paymentMethodId: result.setupIntent.payment_method
              };
            }
          });
        })
        .catch(err => {
          this.setState({
            submitting: false,
            globalError: err
          });

          setTimeout(() => {
            const el = document.getElementById('global-error');
            if (!el) {
              return;
            }
            window.scrollTo({
              top: window.scrollY + el.getBoundingClientRect().y - 20,
              behavior: 'smooth'
            });
          }, 1);
        });
    } else {
      promise = new Promise((resolve) => resolve({}));
    }

    const data = await promise;

    if (!data) {
      return;
    }

    axios.post(endpoint, {...payload, ...data})
      .then(() => {
        let targetUrl = '/signup/completed';
        this.setState({
          submitting: false,
        });
        this.props.router.push(targetUrl);
      })
      .catch(err => {
        if (err.response.status === 400 && err.response.data[0].param !== 'client') {
          const errors = {};
          err.response.data.forEach(error => {
            errors[error.param] = 'Ongeldige waarde';
          });
          this.setState({
            submitting: false,
            errors,
          });
        } else {
          this.props.router.push(`/signup/failed`);
        }
      });
  }

  openSubscriptionModal = () => {
    this.setState({subscriptionModalIsOpen: true});
  };

  closeSubscriptionModal = () => {
    this.setState({subscriptionModalIsOpen: false});
  };

  render() {
    const { subscriptionModalIsOpen, isRendered } = this.state;

    return (
      <form onSubmit={ this.handleSubmit } className="form">
        <fieldset>
          <legend>
            <h2>Contact</h2>
          </legend>
          {this.state.globalError && (
            <a href={`mailto:info@postcodeapi.nu?subject=Foutmelding in accountomgeving&body=${JSON.stringify(this.state.globalError)}`} id="global-error" className="alert">
              Er is een onverwachte fout opgetreden. Klik hier om ons te mailen met details over de foutmelding zodat wij je verder kunnen helpen. Excuses voor het ongemak.
            </a>
          )}
          <div className="formGroup">
            <label>Voor- en achternaam</label>
            <div className="FormInlineGroup">
              <div className={ cx('FormInput', { '-hasError': this.state.errors['firstName'] })}>
                <input name="firstName"
                       value={ this.state.values.firstName }
                       onChange={ this.handleInputChange }
                       onBlur={ this.handleInputBlur } />
                { this.state.errors['firstName'] &&
                <div className="FormError">{ this.state.errors['firstName'] }</div>
                }
              </div>
              <div className={ cx('FormInput', { '-hasError': this.state.errors['lastName'] })}>
                <input name="lastName"
                       value={ this.state.values.lastName }
                       onChange={ this.handleInputChange }
                       onBlur={ this.handleInputBlur } />
                { this.state.errors['lastName'] &&
                <div className="FormError">{ this.state.errors['lastName'] }</div>
                }
              </div>
            </div>
          </div>
          <div className="formGroup">
            <label>E-mailadres</label>
            <div className={ cx('FormInput', { '-hasError': this.state.errors['email'] })}>
              <input name="email"
                     value={ this.state.values.email }
                     onChange={ this.handleInputChange }
                     onBlur={ this.handleInputBlur } />
              { this.state.errors['email'] &&
              <div className="FormError">{ this.state.errors['email'] }</div>
              }
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            <h2>Abonnement</h2>
          </legend>
          <div className="formGroup formGroupCenter">
            <label>Pakket</label>
            <div className="FormInlineGroup">
              <div className={ cx('FormInput') }>
                <div>
                  { planSpecs[this.state.values.subscription.plan].title } ({translations[this.state.values.subscription.period]})
                </div>
              </div>
              <button type="button" className="button buttonSmall" onClick={this.openSubscriptionModal}>Wijzig je pakket</button>
            </div>
          </div>
          <div className="formGroup">
            <label>Looptijd</label>
            <div className="FormInlineGroup">
              <div className={ cx('FormInput') }>
                <div>{ moment(this.state.values.subscription.startsAt).format('DD-MM-YYYY') } t/m { moment(this.state.values.subscription.endsAt).format('DD-MM-YYYY') }</div>
              </div>
            </div>
          </div>
          <div className="formGroup">
            <label>Betaalwijze</label>
            <div className="radiogroup">
              <label>
                <input type="radio" name="paymentMethod" value="creditcard"
                  checked={ this.state.values.paymentMethod === 'creditcard' }
                  onChange={ this.handleInputChange } />
                <span>Creditcard</span>
              </label>
              <label>
                <input type="radio" name="paymentMethod" value="directDebit"
                  checked={ this.state.values.paymentMethod === 'directDebit' }
                  onChange={ this.handleInputChange } />
                <span>Incasso</span>
              </label>
              {this.state.values.subscription.period !== 'month' &&
                <label>
                  <input type="radio" name="paymentMethod" value="bankTransfer"
                          checked={this.state.values.paymentMethod === 'bankTransfer'}
                          onChange={this.handleInputChange}/>
                  <span>Factuur</span>
                </label>
              }
            </div>
          </div>
          {this.state.values.paymentMethod === 'creditcard' &&
           <div className="formGroup">
             <label>Creditcard</label>
             <div className={cx('FormInput -Stripe', { '-hasError': this.state.errors['creditcard'] })}>
              <CardElement options={STRIPE_STYLING}/>
               { this.state.errors['creditcard'] &&
                <div className="FormError">{ this.state.errors['creditcard'] }</div>
               }
             </div>
          </div>
          }
          { this.state.values.paymentMethod === 'directDebit' &&
            <div>
              <div className="formGroup">
                <label>IBAN nummer</label>
                <div className={ cx('FormInput -Stripe', { '-hasError': this.state.errors['debitIban'] })}>
                  <IbanElement
                    options={{
                      ...STRIPE_STYLING,
                      supportedCountries: ['SEPA'],
                      placeholderCountry: 'NL'
                    }}
                  />
                  { this.state.errors['debitCard'] &&
                  <div className="FormError">{ this.state.errors['debitCard'] }</div>
                  }
                </div>
              </div>
              <div className="formGroup">
                <label>Rekeninghouder</label>
                <div className={ cx('FormInput', { '-hasError': this.state.errors['debitOwner'] })}>
                  <input name="debitOwner"
                    value={ this.state.values.debitOwner }
                    onChange={ this.handleInputChange }
                    onBlur={ this.handleInputBlur } />
                  { this.state.errors['debitOwner'] &&
                    <div className="FormError">{ this.state.errors['debitOwner'] }</div>
                  }
                </div>
              </div>
              <div className="formTextWrapper">
                <div className="formText">
                  <small>Door je betaalgegevens door te geven en deze betaling te bevestigen, geef je (A) Postcode API B.V. en Stripe (onze betaaldienst) en/of PPRO, zijn lokale dienstverlener, toestemming om instructies naar je bank te verzenden om het bedrag van je rekening af te schrijven, en (B) geef je je bank toestemming om het bedrag van je rekening af te schrijven conform deze aanwijzingen. Als onderdeel van je rechten kom je in aanmerking voor een terugbetaling van je bank conform de voorwaarden van je overeenkomst met de bank. Je moet terugbetalingen binnen acht weken claimen vanaf de datum waarop het bedrag is afgeschreven van je rekening. Je rechten worden toegelicht in een overzicht dat je bij de bank kunt opvragen. Je gaat ermee akkoord meldingen te ontvangen voor toekomstige afschrijvingen tot twee dagen voordat deze plaatsvinden.</small>
                </div>
              </div>
            </div>
          }
        </fieldset>

        <fieldset>
          <Widget onError={this.handleWidgetError} onSuccess={this.handleWidgetSuccess}>
            <legend>
              <h2>Factuurgegevens</h2>
            </legend>
            <div className="formGroup">
              <label>Bedrijfsnaam</label>
              <div className={ cx('FormInput', { '-hasError': this.state.errors['companyName'] })}>
                <input name="companyName"
                  value={ this.state.values.companyName }
                  onChange={ this.handleInputChange }
                  onBlur={ this.handleInputBlur } />
                { this.state.errors['companyName'] &&
                  <div className="FormError">{ this.state.errors['companyName'] }</div>
                }
              </div>
            </div>
            <div className="formGroup">
              <label>Ter attentie van (optioneel)</label>
              <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceToAttention'] })}>
                <input name="invoiceToAttention"
                  value={ this.state.values.invoiceToAttention }
                  onChange={ this.handleInputChange }
                  onBlur={ this.handleInputBlur } />
                { this.state.errors['invoiceToAttention'] &&
                  <div className="FormError">{ this.state.errors['invoiceToAttention'] }</div>
                }
              </div>
            </div>
            <div className="formGroup">
              <label>Factuur e-mailadres</label>
              <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceEmail'] })}>
                <input name="invoiceEmail"
                  value={ this.state.values.invoiceEmail }
                  onChange={ this.handleInputChange }
                  onBlur={ this.handleInputBlur } />
                { this.state.errors['invoiceEmail'] &&
                  <div className="FormError">{ this.state.errors['invoiceEmail'] }</div>
                }
              </div>
            </div>
            <div className="formGroup">
              <label>Postcode &amp; huisnummer</label>
              <div className="FormInlineGroup">
                <div className={ cx('FormInput', { '-hasError': this.state.errors['invoicePostcode'] })}>
                  <input id="postcode" name="invoicePostcode" placeholder="5038EA"
                    value={ this.state.values.invoicePostcode }
                    onChange={ this.handleInputChange }
                    onBlur={ this.handleInputBlur } />
                  { this.state.errors['invoicePostcode'] &&
                    <div className="FormError">{ this.state.errors['invoicePostcode'] }</div>
                  }
                </div>
                <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceNumber'] })}>
                  <input id="number" name="invoiceNumber" placeholder="19"
                    value={ this.state.values.invoiceNumber }
                    onChange={ this.handleInputChange }
                    onBlur={ this.handleInputBlur } />
                  { this.state.errors['invoiceNumber'] &&
                    <div className="FormError">{ this.state.errors['invoiceNumber'] }</div>
                  }
                </div>
                <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceAddition'] })}>
                  <input name="invoiceAddition" placeholder="A"
                    value={ this.state.values.invoiceAddition }
                    onChange={ this.handleInputChange }
                    onBlur={ this.handleInputBlur } />
                  { this.state.errors['invoiceAddition'] &&
                    <div className="FormError">{ this.state.errors['invoiceAddition'] }</div>
                  }
                </div>
              </div>
            </div>
            <div className="formGroup">
              <label>Straatnaam &amp; plaats</label>
              <div className="FormInlineGroup">
                <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceStreet'] })}>
                  <input id="street" name="invoiceStreet" placeholder="Stationsstraat"
                    value={ this.state.values.invoiceStreet }
                    onChange={ this.handleInputChange }
                    onBlur={ this.handleInputBlur } />
                  { this.state.errors['invoiceStreet'] &&
                    <div className="FormError">{ this.state.errors['invoiceStreet'] }</div>
                  }
                </div>
                <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceCity'] })}>
                  <input id="city" name="invoiceCity" placeholder="Tilburg"
                    value={ this.state.values.invoiceCity }
                    onChange={ this.handleInputChange }
                    onBlur={ this.handleInputBlur } />
                  { this.state.errors['invoiceCity'] &&
                    <div className="FormError">{ this.state.errors['invoiceCity'] }</div>
                  }
                </div>
              </div>
            </div>
            <div className="formGroup">
              <label>Kenmerk (optioneel)</label>
              <div className={ cx('FormInput', { '-hasError': this.state.errors['invoiceReference'] })}>
                <input name="invoiceReference"
                  placeholder="bijv. inkoopordernummer of kostenplaats"
                  value={ this.state.values.invoiceReference }
                  onChange={ this.handleInputChange }
                  onBlur={ this.handleInputBlur } />
                { this.state.errors['invoiceReference'] &&
                  <div className="FormError">{ this.state.errors['invoiceReference'] }</div>
                }
              </div>
            </div>
          </Widget>
          </fieldset>
          <fieldset>
            <div className="formButtonWrapper">
              <p>Door te klikken op ‘registreren’ ga je akkoord met onze <a href="/algemene-voorwaarden" target="_blank">algemene voorwaarden.</a></p>
              { !this.state.submitting &&
                <button type='submit' className={ cx( 'formBtn', "button", "buttonCta" ) }>Opslaan</button>
              }
              { this.state.submitting &&
                <p>Een moment geduld...</p>
              }
            </div>
          </fieldset>
        {isRendered && (
          <Modal isOpen={subscriptionModalIsOpen}
                 className="Modal"
                 overlayClassName="Overlay"
                 onRequestClose={this.state.values.subscription.plan !== 'sandbox' && this.state.values.subscription.plan !== 'free' ? this.closeSubscriptionModal : null}
          >
            <div>
              <h2 className="modalTitle">Wijzig je pakket</h2>
              <CardWrapperModal hasLightBg={true}
                                currentPlan={this.state.values.subscription.plan}
                                oldPlan={''}
                                period={this.state.values.subscription.period}
                                onPeriodChange={this.handlePeriodChange}
                                onCardClick={this.handleSubscriptionChange}/>
            </div>
          </Modal>
        )}
      </form>
    );
  }
}
const SignupForm = (props) => {
  const router = useHistory();
  return <SignupFormWithoutRouter {...props} router={router}/>
}

export default SignupForm;
